import { useRequest } from "ahooks";
import { Button, Modal } from "antd";
import React from "react";
import { ShareRechargeRecordDetailProviderFormValues } from "./type";
import { exportRechargeRecord } from "@/services/api/rechargeRecord";
import TaskStatusEnum from "@/enum/TaskStatusEnum";
import UserType from "@/enum/UserType";

interface ExportShareRechargeRecordDetailButtonProps {
  formValues: ShareRechargeRecordDetailProviderFormValues;
}

const ExportShareRechargeRecordDetailButton: React.FC<ExportShareRechargeRecordDetailButtonProps> = function (props) {
  const { formValues } = props;

  const { loading, run: handleExport } = useRequest(
    async () => {
      const startDate = formValues?.rangeDate?.[0]?.format("YYYY-MM-DD");
      const endDate = formValues?.rangeDate?.[1]?.format("YYYY-MM-DD");

      let listParams = {
        ...(formValues || {}),
        startDate,
        endDate,
        userType: UserType.PROVIDER,
        needRecycleRecords: true,
      };

      delete listParams.rangeDate;

      let { params } = await exportRechargeRecord({ listParams });

      await new Promise((resolve, reject) => {
        const loopFunc = async () => {
          const task = await exportRechargeRecord({ taskId: params?.taskId });

          if ([TaskStatusEnum.PENDING, TaskStatusEnum.RUNNING].includes(task.status)) {
            return setTimeout(loopFunc, 2000);
          }

          if (task.status === TaskStatusEnum.COMPLETED) {
            resolve(null);

            window.open(task.downloadUrl);

            return;
          }

          if (task.status === TaskStatusEnum.ERROR) {
            const msg = task.error || "导出失败";

            Modal.error({ title: "导出失败", content: msg });

            reject(new Error(msg));

            return;
          }

          return;
        };

        setTimeout(loopFunc, 2000);
      });
    },
    { manual: true }
  );

  return (
    <Button type="primary" loading={loading} onClick={handleExport}>
      导出明细
    </Button>
  );
};

export default React.memo(ExportShareRechargeRecordDetailButton);
